import { useAuth } from '../contexts/AuthContext'

type RoleWithPerms = { name: string; permissions?: Array<{ name: string }> }

/**
 * True when the signed-in user holds `permission` through any role (or is a
 * platform superuser). UI-only: the API enforces the same check, this just
 * hides controls that would answer 403.
 */
export function usePermission(permission: string): boolean {
  const { user } = useAuth()
  if (!user) return false
  if (user.is_superuser) return true
  const roles = (user.roles ?? []) as RoleWithPerms[]
  return roles.some((r) => (r.permissions ?? []).some((p) => p.name === permission))
}
